import React, { useState } from "react"
import "react-super-responsive-table/dist/SuperResponsiveTableStyle.css"
import moment from "moment"
import DataTable from "react-data-table-component"
import { useDispatch, useSelector } from "react-redux"
import WalletUpdateModal from "../Payment/walletUpdateModal"
import UserDetailModal from "./userDetailModal"
import { getAllUser, getWalletBalanceByUserId } from "store/actions"
import { getImageForUser } from "utils/Common"
import default_avatar from "../../../assets/images/users/default_avatar.png"
import { USER_TYPE } from "constants/common"

const SeniorCitizenList = () => {
  const dispatch = useDispatch()

  let seniorCitizenList = useSelector(state => state.Users.seniorCitizen.users)
  let page = useSelector(state => state.Users.seniorCitizen.page)

  const [walletModal, setWalletModal] = useState(false)
  const [selectedUser, setSelectedUser] = useState(null)
  const [userDetailModal, setUserDetailModal] = useState(false)

  const [perPage, setPerPage] = useState(10)

  const handlePageChange = page => {
    dispatch(
      getAllUser({
        type: USER_TYPE.SENIOR_CITIZEN,
        page,
        size: perPage,
      })
    )
  }

  const handlePerRowsChange = (newPerPage, page) => {
    dispatch(
      getAllUser({
        type: USER_TYPE.SENIOR_CITIZEN,
        page,
        size: newPerPage,
      })
    )
    setPerPage(newPerPage)
  }

  const columns = [
    {
      id: 1,
      name: "Photo",
      selector: row => row,
      sortable: false,
      reorder: true,
      cell: row => (
        <div style={{ cursor: "pointer" }}>
          <img
            className="rounded-circle header-profile-user"
            src={
              row && row.profileImageURL
                ? getImageForUser(row.id, row.profileImageURL)
                : default_avatar
            }
            alt="Header Avatar"
          ></img>
        </div>
      ),
    },
    {
      id: 2,
      name: "Name",
      selector: row => row.firstName,
      sortable: true,
      reorder: true,
      cell: row => (
        <div style={{ cursor: "pointer" }}>
          <span>
            {row.firstName} {row.lastName}
          </span>
          &nbsp;
          <i
            className="bx bx-info-circle text-primary"
            onClick={() => {
              setSelectedUser(row)
              setUserDetailModal(true)
            }}
          ></i>
        </div>
      ),
    },
    {
      id: 3,
      name: "Contact No.",
      selector: row => row.mobileNumber,
      sortable: true,
      reorder: true,
    },
    {
      id: 4,
      name: "Email",
      selector: row => row.email,
      sortable: true,
      // right: true,
      reorder: true,
    },
    {
      id: 5,
      name: "Joining Date",
      selector: item => (
        <span>
          {moment(item.createdDate).local().format("DD/MM/YYYY hh:mm A")}
        </span>
      ),
      sortable: true,
      // right: true,
      reorder: true,
    },
    {
      button: true,
      cell: item => (
        <div>
          <ul className="list-inline mb-0 font-size-20">
            <li className="list-inline-item">
              <i
                className="bx bx-money text-success"
                onClick={() => {
                  setSelectedUser(item)
                  setWalletModal(true)
                  dispatch(getWalletBalanceByUserId(item.id))
                }}
              ></i>
            </li>
          </ul>
        </div>
      ),
    },
  ]
  
  return (
    <React.Fragment>
      <DataTable
        noHeader
        columns={columns}
        data={seniorCitizenList}
        defaultSortFieldId={1}
        highlightOnHover
        pagination
        paginationServer
        paginationTotalRows={page?.totalElements || 10}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handlePerRowsChange}
      />
      {selectedUser && (
        <WalletUpdateModal
          isOpen={walletModal}
          data={selectedUser}
          closeModal={() => {
            setWalletModal(false)
          }}
        ></WalletUpdateModal>
      )}
      {selectedUser && (
        <UserDetailModal
          isOpen={userDetailModal}
          data={selectedUser}
          closeModal={() => {
            setUserDetailModal(false)
          }}
        ></UserDetailModal>
      )}
    </React.Fragment>
  )
}

export default SeniorCitizenList
